module.exports = __webpack_public_path__ + "static/img/h-head-kiko.d0d73569.png";